import './Main.css'

import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'
import { WizardData } from './Model'
import { goToAddFailurePage, StartAddFailurePage } from '@/pages/communal/machine/failures/add/Main'
import { Machine } from '@/services/model/machine'
import { MachineName } from '@/components/machine'
import { useNavigate } from 'react-router-dom'
import { MachineFailureCategory } from '@/services/repository/machines'
import { useEffect, useRef, useState } from 'react'

enum Expected {
  Positive = 'expected_positive',
  Negative = 'expected_negative',
}

interface Question {
  expected: Expected
  questionId: string
}

const Questions = {
  random_question: {
    [Expected.Positive]: ['alko', 'water'],
    [Expected.Negative]: ['alko', 'water'],
  }
}

function randomFromArray<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

function RandomQuestion(): Question {
  const expected = randomFromArray([Expected.Positive, Expected.Negative])
  const questionId = randomFromArray(Questions.random_question[expected])
  return {
    expected,
    questionId
  }
}

export const OperatorCheckStep = ({ machine }: {
  machine: Machine
}) => {
  const { services, session, translates } = useAppContext()
  const navigate = useNavigate()
  const { wizardData, updateWizardData, nextStep, firstStep } = useWizard<WizardData>()
  const [question, setQuestion] = useState(RandomQuestion())
  const didRun = useRef(false);

  useEffect(() => {
    // Prevent double-run in React 18 StrictMode (development)
    if (didRun.current) return;
    didRun.current = true;

    // Run only ~20% of mounts
    if (Math.random() < 0.2) {
      nextStep()
    }
  }, []);

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <div>
    <h3>{translates.for(`machine.checklist.wizard.operator_check.random_question.${question.expected}.${question.questionId}.title`)}</h3>
    <p className='desc'>
      {translates.for(`machine.checklist.wizard.operator_check.random_question.${question.expected}.${question.questionId}.question`)}
    </p>
    
    <div className='btns'>
      <a className='btn btn-next main-btn' onClick={() => {
        if(question.expected == Expected.Negative) {
          nextStep()
          return
        }
        firstStep()
      }}>
        {translates.for('elements.dialog.yesno.no')}
      </a>
      <a className='btn btn-next main-btn' onClick={() => {
        if(question.expected == Expected.Positive) {
          nextStep()
          return
        }
        firstStep()
      }}>
        {translates.for('elements.dialog.yesno.yes')}
      </a>
    </div>

  </div>
}
